// extracted by mini-css-extract-plugin
export var footer = "_oz-0";
export var inherit = "_oz-1";
export var input = "_oz-2";
export var modalContent = "_oz-3";
export var quillEditor = "_oz-4";
export var subtitle = "_oz-5";